<template>
  <div class="container">
    <Loader v-if="isLoading" />

    <div v-else class="Donation-image">
      <div class="Donation-image__title">
        <p>
          <b>Kurban Videonuz. Allah kabul etsin.</b>
        </p>
      </div>
      <div class="Donation-image__images">
        <div>
          <video width="100%" height="100%" controls>
            <source :src="img(video)" type="video/mp4" />
          </video>
        </div>
      </div>

      <div class="Donation-image__share">
        <p>Sosyal Medyada Paylaş</p>
        <a :href="wpLink" data-action="share/whatsapp/share">
          <i class="fab fa-whatsapp"></i>
        </a>
        <a target="_blank" href="https://www.facebook.com/sharer/sharer.php?u=#url">
          <i class="fab fa-facebook"></i>
        </a>
        <a target="_blank" :href="twitterLink">
          <i class="fab fa-twitter"></i>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isLoading: true,
      video: '',
      wpLink: '',
      twitterLink: ''
    }
  },
  created() {
    const { id } = this.$route.params
    const { token } = this.$route.params

    this.$http.get(`qurban/${id}/video?token=${token}`).then((res) => {
      this.video = res.data.video
      console.log(this.video)

      this.isLoading = false
    })

    this.wpLink = `whatsapp://send?text=http://bagis.ismailagadernegi.org.tr${this.$route.fullPath}`
    this.twitterLink = `https://twitter.com/intent/tweet?text=http://bagis.ismailagadernegi.org.tr${this.$route.fullPath}`
  }
}
</script>
